export default {
  navbar: {
    blocks: "Blocks",
    transactions: "Transactions",
    producers: "Producers",
    holders: "Holders",
    dapps: "DApps"
  }
}
